import React from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from '@mui/material'

const CustomActionButton = ({
  label,
  hint,
  icon = "",
  handleOnClick,
}) => {
  return (
    <Tooltip title={hint}>
      <Button
        variant='contained'
        onClick={handleOnClick}
        sx={{ ml: 2 }}
        startIcon={icon}
      >
        {label}
      </Button>
    </Tooltip>
  )
}

CustomActionButton.propTypes = {

  /** Text to display as a button label */
  label: PropTypes.string.isRequired,

  /** Tooltip him to display when focusing on a button */
  hint: PropTypes.string.isRequired,

  /** Button decorator icon, if desired */
  icon: PropTypes.node,

  /** Callback function on click of the button */
  handleOnClick: PropTypes.func.isRequired,

}

export default CustomActionButton
